// /citizen/greenpillLeaderboard?fetchUserEntry=false&page=<page_number>&entriesPerPage=<entry_count></entry_count>
import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';

const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getGreenpillLeaderboard = async (collectionNo, accountDetails, page, entriesPerPage = 10, isUserEntry) => {
    const queryString = isUserEntry
        ? `fetchUserEntry=${isUserEntry}${collectionNo ? `&nftCollectionNumber=${collectionNo}` : ''}`
        : `fetchUserEntry=${isUserEntry}&page=${page}&entriesPerPage=${entriesPerPage}${
              collectionNo ? `&nftCollectionNumber=${collectionNo}` : ''
          }`;
    try {
        const url = `${BASE_URL}/citizen/greenpillLeaderboard?${queryString}`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status === 201) {
            return {
                status: response.status,
                data: response?.data,
            };
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};

export const getEntryCount = async (collectionNo) => {
    try {
        const url = `${BASE_URL}/citizen/greenpillLeaderboardEntryCount${
            collectionNo ? `?nftCollectionNumber=${collectionNo}` : ''
        }`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));

        if (response.status === 200 || response.status == 201) {
            return {
                status: response.status,
                data: response?.data?.entryCount,
            };
        }
    } catch (error) {
        return error;
    }
};
